import _ from 'lodash';
import { ChangeEvent, FC, useState } from 'react';
import Button from 'v3/common/components/Button';

const OTP_LENGTH = 6;

enum RESEND_LABELS {
  resend = 'resend',
  sending = 'sending',
}

type OtpFormProps = {
  phoneNumber: string | number;
  onResendOtp: () => void;
  routePath: string;
};
const OtpForm: FC<OtpFormProps> = ({ phoneNumber, onResendOtp, routePath }) => {
  const [otp, setOtp] = useState('');
  const [resendLabel, setResendLabel] = useState(RESEND_LABELS.resend);
  const [isResendingOtp, setIsResendingOtp] = useState(false);

  const onOtpChange = (event: ChangeEvent<HTMLInputElement>) => {
    const {
      target: { value },
    } = event;
    if (value.length > OTP_LENGTH) return;

    setOtp(value);
  };

  const onClickResendOtp = () => {
    setIsResendingOtp(true);
    setResendLabel(RESEND_LABELS.sending);

    setTimeout(() => {
      setIsResendingOtp(false);
      setResendLabel(RESEND_LABELS.resend);
    }, 2000);

    onResendOtp();
  };

  return (
    <div className="otp-form-container">
      <div className="text-center">
        <img alt="smartphone" src="/smartphones-notification.svg" />
        <h4 className="font-weight-bold mb-1">OTP Verification</h4>
        <h5 className="text-muted">
          Enter the OTP sent to
          <span className="font-weight-bold mx-2">{phoneNumber}</span>
        </h5>
      </div>
      <form className="text-center mt-4" method="post" action="/verify_otp">
        <input type="hidden" value={routePath} name="route_path" />
        <input
          type="number"
          key="otp"
          className="otp-input"
          name="otp"
          value={otp}
          onChange={onOtpChange}
          autoFocus
        />
        <input type="hidden" name="phone_number" value={phoneNumber} />

        <div className="d-flex align-items-center justify-content-center gap-20">
          <h6 className="my-5 text-muted">
            Didn&lsquo;t receive OTP?
            <span className="text-primary cursor-pointer font-weight-bold mx-2" onClick={onClickResendOtp}>
              {_.startCase(resendLabel)}
            </span>
          </h6>
          {isResendingOtp && <div className="dot-elastic " />}
        </div>

        <Button
          className="btn btn-primary btn-pill text-uppercase"
          type="submit"
          disabled={otp.length < OTP_LENGTH}
        >
          Verify & Continue
        </Button>
      </form>
    </div>
  );
};

export default OtpForm;
